import { render, staticRenderFns } from "./MenuItemPrice.vue?vue&type=template&id=5215003e&scoped=true"
import script from "./MenuItemPrice.vue?vue&type=script&lang=ts"
export * from "./MenuItemPrice.vue?vue&type=script&lang=ts"
import style0 from "./MenuItemPrice.vue?vue&type=style&index=0&id=5215003e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5215003e",
  null
  
)

export default component.exports